import { configureStore } from '@reduxjs/toolkit';

import { coursesApi } from '../features/my-courses/coursesApi';
import { unitsApi } from '../features/units/unitsApi';
import { lessonsApi } from '../features/lessons/lessonsApi';
import { standardsApi } from '../features/standardsWarehouse/standardsWarehouseApi';
import coursesReducer from '../features/my-courses/coursesSlice';
import authReducer from '../features/auth/authSlice';
import unitsReducer from '../features/units/unitsSlice';
import lessonsReducer from '../features/lessons/lessonsSlice';
import rubricsReducer from '../features/rubrics/rubricsSlice';
import uiReducer from '../shared/store/uiSlice';
import slideEditorReducer from '../features/slides/slideEditorSlice';
import standardsCartReducer from '../features/userStandards/cartSlice';

import { rubricsApi } from '@/features/rubrics/rubricsApi';
import { resourcesApi } from '@/features/resources/resourcesApi';
import { standardsCatalogApi } from '@/features/userStandards/standardsCatalogApi';
import { customStandardsApi } from '@/features/customStandards/customStandardsApi';
import { permissionsApi } from '@/features/permissions/permissionsApi';
import { teamsApi } from '@/features/teams/teamsApi';

// Create the store - add slices here as you create them
export const store = configureStore({
  reducer: {
    // Add your reducers/slices here
    courses: coursesReducer,
    auth: authReducer,
    units: unitsReducer,
    lessons: lessonsReducer,
    standardsCart: standardsCartReducer,
    ui: uiReducer,
    slideEditor: slideEditorReducer,
    [coursesApi.reducerPath]: coursesApi.reducer,
    [unitsApi.reducerPath]: unitsApi.reducer,
    [lessonsApi.reducerPath]: lessonsApi.reducer,
    [standardsApi.reducerPath]: standardsApi.reducer,
    [customStandardsApi.reducerPath]: customStandardsApi.reducer,
    [standardsCatalogApi.reducerPath]: standardsCatalogApi.reducer,
    [teamsApi.reducerPath]: teamsApi.reducer,
    [permissionsApi.reducerPath]: permissionsApi.reducer,
    [resourcesApi.reducerPath]: resourcesApi.reducer,
    [rubricsApi.reducerPath]: rubricsApi.reducer,
    rubrics: rubricsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(
      coursesApi.middleware,
      unitsApi.middleware,
      lessonsApi.middleware,
      standardsApi.middleware,
      customStandardsApi.middleware,
      standardsCatalogApi.middleware,
      teamsApi.middleware,
      permissionsApi.middleware,
      resourcesApi.middleware,
      rubricsApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
